import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {createConfigSetting,updateConfigSetting,fetchAllConfigSettings} from '../../core/data/redux/user/configurationSetting/configurationSettingsActions';
import { Select, Input, Radio, Button, Typography, Divider, Checkbox, message } from 'antd';
import { AppDispatch } from '../../core/data/redux/store';
import axios from 'axios';
import timeZones from './timezone';

const { Title } = Typography;
const { Option } = Select;

const RegionalSettingsConfig = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: any) => state.auth);
    const { loadingStates, records } = useSelector((state: any) => state.configurationSettings);
    const [pfType, setPfType] = useState<'PF' | 'GPF'>('PF');
    const [countries, setCountries] = useState<any[]>([]);
    const [states, setStates] = useState<any[]>([]);
    const [availableTimeZones, setAvailableTimeZones] = useState<string[]>([]);

    const isLoading = loadingStates.update;

    const [form, setForm] = useState<any>({
        date_format: 'DD/MM/YYYY',
        date_separator: '-',
        currency_symbol: '₹',
        currency_string: 'Rupees',
        currency_decimal_places: 2,
        currency_font: 'Rupee Foradian',
        currency_character: '₹',
        number_format: '9,99,99,999.99',
        skip_currency_separator: 'N',
        time_format: '12 Hours',
        country: 'India',
        state: 'Delhi',
        tds_on_salary: true,
        tds_zero_ref: false,
        tds_proportional: false,
        tds_surcharge_enabled: 'N',
        tds_applicable_income: '',
        professional_tax_enabled: true,
        pf_reporting_enabled: true,
        pf_account_number: '',
        pf_signatory_name: '',
        esi_reporting_enabled: false,
        esi_code: '',
        esi_employer_name: '',
        esi_designation: '',
        esi_address: '',
        createdBy: user?.UserId,
        modifiedBy: user?.UserId,
        timezone:'',
    });
    useEffect(() => {
        if (!records.length) {
            dispatch(fetchAllConfigSettings());
        }
    }, [dispatch, records.length]);

    useEffect(() => {
        if (records && records.length > 0) {
            const loaded = records[0];
            setForm((prev: any) => ({
                ...prev,
                ...loaded,
            }));

            const isPfEnabled = String(loaded.pf_reporting_enabled) === '1' || loaded.pf_reporting_enabled === true;
            setPfType(isPfEnabled ? 'PF' : 'GPF');
        }
    }, [records]);

    useEffect(() => {
        axios
            .get('https://partnerapi.leadchainsystems.in/api/v1/countries', {
                headers: {
                    Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI5NjUwYWU5MC03YjRmLTQ5MWUtODVlOC1iMjM1ZmQyODlkMDAiLCJpYXQiOjE3MzQzNDczODl9.XWRyYTdl_10enuZkBCK1-WInCOGmiGW5PKZzJelrobY'
                }
            })
            .then((response) => {
                setCountries(response.data);
            })
            .catch((error) => {
                console.error('Error fetching countries:', error);
                message.error('Failed to fetch country list.');
            });
    }, []);

    const handleCountryChange = (countryName: string) => {
        handleInputChange('country', countryName);
        const selectedCountry = timeZones.find(item => item.country === countryName);
        if (selectedCountry) {
            setAvailableTimeZones(selectedCountry.timeZones); // Set available time zones for selected country
        } else {
            setAvailableTimeZones([]); // Default case if no time zones are found
        }
        axios
            .get(`https://partnerapi.leadchainsystems.in/api/v1/countries/${countryName}/states`, {
                headers: {
                    Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI5NjUwYWU5MC03YjRmLTQ5MWUtODVlOC1iMjM1ZmQyODlkMDAiLCJpYXQiOjE3MzQzNDczODl9.XWRyYTdl_10enuZkBCK1-WInCOGmiGW5PKZzJelrobY'
                }
            })
            .then((response) => {
                setStates(response.data);
            })
            .catch((error) => {
                console.error('Error fetching states:', error);
                message.error('Failed to fetch states.');
            });
    };

    const handlePfTypeChange = (value: 'PF' | 'GPF') => {
        setPfType(value);
        handleInputChange('pf_reporting_enabled', value === 'PF' ? 1 : 0);
    };

    const handleInputChange = (field: string, value: any) => {
        setForm((prev: any) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = () => {
        const {
            createdAt,
            modifiedAt,
            id,
            ...cleanForm
        } = form;

        const finalPayload = {
            ...cleanForm,
            modifiedBy: user?.UserId,
            ...(records.length === 0 && { createdBy: user?.UserId }),
        };

        if (records.length && records[0].id) {
            dispatch(updateConfigSetting({ id: records[0].id, data: finalPayload }))
                .unwrap()
                .then(() => message.success('Configuration updated successfully!'))
                .catch(() => message.error('Failed to update configuration.'));
        } else {
            dispatch(createConfigSetting(finalPayload))
                .unwrap()
                .then(() => message.success('Configuration created successfully!'))
                .catch(() => message.error('Failed to create configuration.'));
        }
    };
    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="container mt-4 p-4 border rounded card" style={{ background: '#f8f9fa' }}>
                    <Title level={4} className="text-center" style={{ background: '#8B0000', color: 'white', padding: '10px' }}>
                        Configuration Settings
                    </Title>

                    {/* Form Inputs */}
                    <div className="row g-3 mt-3">
                        <div className="col-md-6">
                            <label>Date Format</label>
                            <Select
                                value={form.date_format}
                                onChange={(val) => handleInputChange('date_format', val)}
                                className="w-100"
                            >
                                <Option value="DD/MM/YYYY">DD/MM/YYYY</Option>
                                <Option value="MM/DD/YYYY">MM/DD/YYYY</Option>
                            </Select>
                        </div>

                        <div className="col-md-6">
                            <label>Date Separator</label>
                            <Input value={form.date_separator} onChange={(e) => handleInputChange('date_separator', e.target.value)} />
                        </div>

                        <div className="col-md-6">
                            <label>Currency Symbol</label>
                            <Input value={form.currency_symbol} onChange={(e) => handleInputChange('currency_symbol', e.target.value)} />
                        </div>

                        <div className="col-md-6">
                            <label>Currency String</label>
                            <Input value={form.currency_string} onChange={(e) => handleInputChange('currency_string', e.target.value)} />
                        </div>

                        <div className="col-md-6">
                            <label>Currency Decimal Places</label>
                            <Input
                                type="number"
                                value={form.currency_decimal_places}
                                onChange={(e) => handleInputChange('currency_decimal_places', Number(e.target.value))}
                            />
                        </div>

                        <div className="col-md-6">
                            <label>Currency Font</label>
                            <Input value={form.currency_font} onChange={(e) => handleInputChange('currency_font', e.target.value)} />
                        </div>

                        <div className="col-md-6">
                            <label>Currency Character</label>
                            <Input value={form.currency_character} onChange={(e) => handleInputChange('currency_character', e.target.value)} />
                        </div>

                        <div className="col-md-6">
                            <label>Number Format</label>
                            <Input value={form.number_format} onChange={(e) => handleInputChange('number_format', e.target.value)} />
                        </div>

                        <div className="col-md-6">
                            <label>Skip Currency Separator</label>
                            <Select value={form.skip_currency_separator} onChange={(val) => handleInputChange('skip_currency_separator', val)} className="w-100">
                                <Option value="Y">Y</Option>
                                <Option value="N">N</Option>
                            </Select>
                        </div>

                        <div className="col-md-6 mt-4">
                            <label className='pe-2'>Time Format</label>
                            <Radio.Group
                                value={form.time_format}
                                onChange={(e) => handleInputChange('time_format', e.target.value)}
                            >
                                <Radio value="12 Hours">12 Hours</Radio>
                                <Radio value="24 Hours">24 Hours</Radio>
                            </Radio.Group>
                        </div>
                    </div>

                    <Divider />
                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label>Country</label>
                            <Select
                                value={form.country}
                                onChange={handleCountryChange}
                                className="w-100"
                            >
                                {countries.map((country) => (
                                    <Option key={country.iso_code} value={country.name}>
                                        {country.name}
                                    </Option>
                                ))}
                            </Select>
                        </div>

                        <div className="col-md-6">
                            <label>State</label>
                            <Select
                                value={form.state}
                                onChange={(val) => handleInputChange('state', val)}
                                className="w-100"
                            >
                                {states.map((state) => (
                                    <Option key={state.name} value={state.name}>
                                        {state.name}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-md-6">
                            <label>Time Zone</label>
                            <Select
                                value={form.timezone}
                                onChange={(val) => handleInputChange('timezone', val)}
                                className="w-100"
                            >
                                {availableTimeZones.map((zone, index) => (
                                    <Option key={index} value={zone}>
                                        {zone}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>

                    <Divider />
                    <Title level={5}>TDS Configuration</Title>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <Checkbox checked={form.tds_on_salary} onChange={(e) => handleInputChange('tds_on_salary', e.target.checked)}>
                                Enable TDS on Salary
                            </Checkbox>
                        </div>
                        <div className="col-md-6">
                            <Checkbox checked={form.tds_zero_ref} onChange={(e) => handleInputChange('tds_zero_ref', e.target.checked)}>
                                Maintain Zero Amount TDS Reference
                            </Checkbox>
                        </div>
                        <div className="col-md-6">
                            <Checkbox checked={form.tds_proportional} onChange={(e) => handleInputChange('tds_proportional', e.target.checked)}>
                                Deduct TDS proportional to paid days
                            </Checkbox>
                        </div>
                        <div className="col-md-12">
                            <label><strong style={{ color: 'purple' }}>TDS Surcharge Details</strong></label>
                            <div className="d-flex align-items-center gap-3 mt-2">
                                <span>Enable Surcharge on TDS</span>
                                <Select
                                    value={form.tds_surcharge_enabled}
                                    onChange={(val) => handleInputChange('tds_surcharge_enabled', val)}
                                    style={{ width: 100 }}
                                >
                                    <Option value="Y">Y</Option>
                                    <Option value="N">N</Option>
                                </Select>
                                <Input
                                    value={form.tds_applicable_income}
                                    onChange={(e) => handleInputChange('tds_applicable_income', e.target.value)}
                                    style={{ width: 250 }}
                                />
                            </div>
                        </div>
                    </div>

                    <Divider />
                    <Title level={5}>Provident Fund Type</Title>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <Radio.Group
                                value={pfType}
                                onChange={(e) => handlePfTypeChange(e.target.value)}
                            >
                                <Radio value="PF">EPF</Radio>
                                <Radio value="GPF">GPF</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    {/* <Title level={5}>{pfType === 'PF' ? 'PF Configuration' : 'GPF Configuration'}</Title> */}
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label>{pfType} A/C No.</label>
                            <Input value={form.pf_account_number} onChange={(e) => handleInputChange('pf_account_number', e.target.value)} />
                        </div>
                        <div className="col-md-6">
                            <label>Authorised Signatory Name</label>
                            <Input value={form.pf_signatory_name} onChange={(e) => handleInputChange('pf_signatory_name', e.target.value)} />
                        </div>
                    </div>


                    <Divider />
                    <Title level={5}>ESI Configuration</Title>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <Checkbox checked={form.esi_reporting_enabled} onChange={(e) => handleInputChange('esi_reporting_enabled', e.target.checked)}>
                                Enable ESI Reporting
                            </Checkbox>
                        </div>
                        <div className="col-md-6">
                            <label>ESI Code</label>
                            <Input value={form.esi_code} onChange={(e) => handleInputChange('esi_code', e.target.value)} />
                        </div>
                        <div className="col-md-6">
                            <label>Prime Employer Name</label>
                            <Input value={form.esi_employer_name} onChange={(e) => handleInputChange('esi_employer_name', e.target.value)} />
                        </div>
                        <div className="col-md-6">
                            <label>Designation</label>
                            <Input value={form.esi_designation} onChange={(e) => handleInputChange('esi_designation', e.target.value)} />
                        </div>
                        <div className="col-md-12">
                            <label>Address</label>
                            <Input.TextArea rows={2} value={form.esi_address} onChange={(e) => handleInputChange('esi_address', e.target.value)} />
                        </div>
                    </div>

                    <div className="d-flex justify-content-center gap-3 mt-4">
                        <Button
                            type="primary"
                            onClick={handleSubmit}
                            disabled={isLoading}
                        >
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegionalSettingsConfig;
